import { isUndefinedOrEmpty, reverse } from './string'

interface requiredAddressFieldsByCountryType {
  [key: string]: {
    [key: string]: boolean
  }
}

interface AddressFields {
  [key: string]: boolean
}

export const EMAIL_VALID_LENGTH = 320

export const requiredAddressFieldsByCountry: requiredAddressFieldsByCountryType = {
  AU: {
    state: true,
    postcode: true,
    suburb: true,
  },
  NZ: {
    state: true,
    postcode: true,
    suburb: true,
  },
  US: {
    state: true,
    postcode: true,
    suburb: true,
  },
  CA: {
    state: true,
    postcode: true,
    suburb: true,
  },
  GB: {
    state: false,
    postcode: true,
    suburb: true,
  },
  IM: {
    state: false,
    postcode: true,
    suburb: true,
  },
  JE: {
    state: false,
    postcode: true,
    suburb: true,
  },
  GG: {
    state: false,
    postcode: true,
    suburb: true,
  },
  DEFAULT: {
    state: false,
    postcode: false,
    suburb: true,
  },
}

type Country = keyof typeof requiredAddressFieldsByCountry

interface AddressValidation {
  input: string
  optional?: boolean
}

export const isValidAddress = ({ input, optional = false }: AddressValidation): boolean => {
  if (optional && isUndefinedOrEmpty(input)) {
    return true
  }
  if (isUndefinedOrEmpty(input)) {
    return false
  }

  // TODO: Add PO Box validation
  return true
}

export const getAddressOptionalFields = (country: Country): string[] => {
  const requiredFields = requiredAddressFieldsByCountry[country] ?? (requiredAddressFieldsByCountry.DEFAULT as AddressFields)
  const optionalFields = Object.keys(requiredFields).filter((key) => !requiredFields[key])
  return optionalFields
}

export const valueIsNotNullOrUndefined = <T>(value: T | undefined | null): value is T => {
  return value !== null && value !== undefined
}

export const isNullOrUndefined = <T>(value: T | undefined | null): value is undefined | null => {
  return value === null || value === undefined
}

// Type guards
export const valueIsStringAndNotNullOrUndefined = (value: any): value is string => valueIsNotNullOrUndefined(value)

export const isValidEmail = (email: string): boolean => {
  if (isUndefinedOrEmpty(email)) {
    return false
  }
  const emailRegex = /\S+@\S+\.\S+$/
  const blackListedRegex = /afterpayshadow\.invalid$/i
  // Note: Safari does not support Lookbehind regex
  // Reversed email to check lookahead
  const reversedEmail = reverse(email)
  const startWithDotRegex = /^(?!\.)\S+/
  const firstEmailPart = email.split('@')[0]
  return (
    typeof firstEmailPart !== 'undefined' &&
    email.length <= EMAIL_VALID_LENGTH &&
    emailRegex.test(email) &&
    startWithDotRegex.test(reversedEmail) &&
    !firstEmailPart.includes('*') &&
    !blackListedRegex.test(email)
  )
}

export const isMobileNumberValid = (mobile?: string): boolean => {
  if (!mobile || isUndefinedOrEmpty(mobile)) {
    return false
  } else {
    if (mobile.length > 1) {
      const digitsOnlyPattern = /^\+?\d+$/
      const spaceRegex = /\s+/g
      return Boolean(mobile.replace(spaceRegex, '').match(digitsOnlyPattern))
    } else {
      return false
    }
  }
}
